import React from 'react';
import "./header.css"
import CTA from './CTA';
import {FaArrowCircleRight} from "react-icons/fa"
import HeaderSocials from './HeaderSocials';
const Header = () => {
  return (
    <header className="nav-link home" id="home">
    <div className='container header_container'>
      <h2>Hello 👋.</h2>
      <h1  id="user-detail-name">I'm Pritam Halder</h1>
      <h5 className='text-light'>Aspiring Full Stack Web Developer at Masai School, Life Long Learner</h5>
      <CTA/>
      <HeaderSocials/>
      <a href="#contact" className='scroll_down'><FaArrowCircleRight size={25}/></a>
    </div>
    </header>
  );
}

export default Header;
